import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";

const BlogTable = ({ blog }) => {
  const [search, setSearch] = useState("");
  const [filterBlogs, setFilterBlogs] = useState("");

  const colums = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.b_status,
      cell: (row) => (row.b_status ? "Active" : "Inactive"),
    },
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Subtitle",
      selector: (row) => row.subtitle,
    },
    {
      name: "Author",
      selector: (row) => row.author,
    },
    {
      name: "Publiationn Date",
      selector: (row) => row.pub_date,
    },
    {
      name: "Image",
      selector: (row) => (
        <img
          src={row.image}
          alt="logo"
          height="50"
          width="50"
          style={{ borderRadius: "50%", margin: "10px" }}
        />
      ),
    },
    {
      name: "Action",
      selector: (row) => (
        <ul className="d-flex gap-2 list-unstyled mb-0">
          <li>
            <Link
              to={`/blog-update/${row.id}`}
              className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
            >
              <i className="ph-pencil"></i>
            </Link>
          </li>
          <li>
            <Link
              to="#BlogDeleteModal"
              data-bs-toggle="modal"
              className="btn btn-subtle-danger btn-icon btn-sm remove-item-btn"
            >
              <i className="ph-trash"></i>
            </Link>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    const result =
      blog &&
      blog.filter((data) => {
        const nameMatch = data.title
          .toLowerCase()
          .includes(search.toLowerCase());
        const idMatch = String(data.id).includes(search.toLowerCase());
        return nameMatch || idMatch;
      });
    setFilterBlogs(result);
  }, [search, blog]);

  return (
    <DataTable
      columns={colums}
      data={filterBlogs}
      pagination
      fixedHeader
      fixedHeaderScrollHeight="450px"
      selectableRows
      selectableRowsHighlight
      highlightOnHover
      subHeader
      subHeaderComponent={
        <input
          type="text"
          placeholder="Search here"
          className="w-100 form-control"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        ></input>
      }
      subHeaderAlign="left"
    />
  );
};

export default BlogTable;
